import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FormControl, InputLabel, Select, MenuItem, TextField, IconButton, Divider } from '@mui/material';

const AirCompressorModal = ({ show, onHide }) => {
  const [step, setStep] = useState(0);

  const [setup, setSetup] = useState({
    compressorCount: '',
    voltage: '',
    costPerKwh: ''
  });

  const [compressors, setCompressors] = useState([]);

  const next = () => setStep(prev => prev + 1);
  const back = () => setStep(prev => prev - 1);

  const handleSetupSubmit = () => {
    const count = Number(setup.compressorCount);

    const initialCompressors = Array.from({ length: count }, () => ({
      type: '',
      drive: '',
      powerFactor: 0.85
    }));

    setCompressors(initialCompressors);
    next();
  };

  const handleCompressorChange = (index, field, value) => {
    const updated = [...compressors];
    updated[index][field] = value;
    setCompressors(updated);
  };

  const handleFinish = () => {
    const payload = {
      setup,
      compressors
    };

    console.log('Final Payload:', payload);
    onHide();
  };

  const renderBody = () => {
    if (step === 0) {
      return (
        <SetupPage
          setup={setup}
          setSetup={setSetup}
          onNext={handleSetupSubmit}
        />
      );
    }

    const index = step - 1;

    return (
      <CompressorPage
        index={index}
        data={compressors[index]}
        onChange={handleCompressorChange}
        onNext={next}
        onBack={back}
        isLast={step === compressors.length}
        onFinish={handleFinish}
      />
    );
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Air Compressors</Modal.Title>
      </Modal.Header>

      <Modal.Body>{renderBody()}</Modal.Body>

     
    </Modal>
  );
};

/* =============================
   Setup Page
============================= */
const SetupPage = ({ setup, setSetup, onNext }) => (
  <Form>

    <Form.Group className="mb-3">
      <Form.Label>Number of Air Compressors</Form.Label>
      <Form.Control
        type="number"
        value={setup.compressorCount}
        onChange={e =>
          setSetup({ ...setup, compressorCount: e.target.value })
        }
      />
    </Form.Group>

    <Form.Group className="mb-3">
      <Form.Label>Voltage</Form.Label>
      <Form.Control
        type="number"
        value={setup.voltage}
        onChange={e =>
          setSetup({ ...setup, voltage: e.target.value })
        }
      />
    </Form.Group>

    <Form.Group className="mb-3">
      <Form.Label>Cost ($/kWh)</Form.Label>
      <Form.Control
        type="number"
        step="0.01"
        value={setup.costPerKwh}
        onChange={e =>
          setSetup({ ...setup, costPerKwh: e.target.value })
        }
      />
    </Form.Group>

    <Button onClick={onNext}>Next</Button>
  </Form>
);

/* =============================
   Compressor Page
============================= */
const CompressorPage = ({
  index,
  data,
  onChange,
  onNext,
  onBack,
  isLast,
  onFinish
}) => (
  <Form>
    <h5 className="mb-3">Air Compressor {index + 1}</h5>

    <Form.Group className="mb-3">
      <Form.Label>Type</Form.Label>
      <Form.Select
        value={data.type}
        onChange={e => onChange(index, 'type', e.target.value)}
      >
        <option value="">Select</option>
        <option value="screw">Screw</option>
        <option value="piston">Piston</option>
      </Form.Select>
    </Form.Group>

    <Form.Group className="mb-3">
      <Form.Label>Drive</Form.Label>
      <Form.Select
        value={data.drive}
        onChange={e => onChange(index, 'drive', e.target.value)}
      >
        <option value="">Select</option>
        <option value="single_speed">Single Speed</option>
        <option value="vfd">VFD</option>
      </Form.Select>
    </Form.Group>

    <Form.Group className="mb-3">
      <Form.Label>Power Factor</Form.Label>
      <Form.Control
        type="number"
        step="0.01"
        value={data.powerFactor}
        onChange={e =>
          onChange(index, 'powerFactor', Number(e.target.value))
        }
      />
    </Form.Group>

    <div className="d-flex justify-content-between">
      <Button variant="secondary" onClick={onBack}>
        Back
      </Button>

      {isLast ? (
        <Button variant="primary" onClick={onFinish}>
          Finish
        </Button>
      ) : (
        <Button variant="primary" onClick={onNext}>
          Next
        </Button>
      )}
    </div>
  </Form>
);

export default AirCompressorModal;
